// extracted by mini-css-extract-plugin
export default {"btn":"IconButton_btn__qTqad","border":"IconButton_border__0rv8C"};